module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/icon-step-1_040288ab04141f3ef5a57f70c608ac22.png";